import { render, staticRenderFns } from "./DbGisSettings.vue?vue&type=template&id=22fed128&scoped=true&"
import script from "./DbGisSettings.vue?vue&type=script&lang=js&"
export * from "./DbGisSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fed128",
  null
  
)

export default component.exports